var _path, _rect, _rect2, _path2, _rect3, _rect4, _path3, _path4, _path5, _path6, _path7, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 336,
    height: 201,
    fill: "none",
    viewBox: "0 0 336 201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4D04E",
    d: "M0 .5h336v200H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 95,
    x: 87.996,
    y: 77.729,
    fill: "#fff",
    rx: 47.5,
    transform: "rotate(-45 87.996 77.729)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 95,
    x: 54.055,
    y: 77.729,
    fill: "#111",
    rx: 47.5,
    transform: "rotate(-45 54.055 77.729)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M234.864 209.036 451.4-7.5l67.175 67.175-216.536 216.536z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 95,
    x: 20.114,
    y: 77.729,
    fill: "#fff",
    rx: 47.5,
    transform: "rotate(-45 20.114 77.729)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 204.19,
    height: 270.554,
    fill: "#111",
    rx: 102.095,
    transform: "scale(-1 1) rotate(45 -103.887 14.564)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 3,
    d: "m6.69-357.5 135.583 135.727c12.481 12.494 12.481 32.737 0 45.231L-45.544 11.475c-12.481 12.494-12.481 32.737 0 45.23L107.088 209.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 3,
    d: "M69.965 71.719v23.334h23.334M136.079 52.273V28.94h-23.334M102.845 38.838v46.67M210.364-37.5l60.873 60.873c12.497 12.496 12.497 32.758 0 45.254l-77.745 77.746c-12.497 12.496-12.497 32.758 0 45.254l69.872 69.873"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 3,
    d: "m253.339 149.574-12.144 12.145 14.256 14.257v12.672h12.673l13.729 13.729 12.145-12.145M278.685 124.228l-12.145 12.145 14.257 14.257v12.673h12.673l13.729 13.729 12.145-12.145M304.031 98.883l-12.145 12.144 14.257 14.257v12.673h12.673l13.729 13.729 12.144-12.145M329.376 73.537l-12.145 12.145 14.257 14.257v12.672h12.673l13.729 13.729 12.145-12.144"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 5,
    d: "m354.722 48.191-12.145 12.145 14.257 14.257v12.673h12.673l13.729 13.729 12.145-12.145"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 285,
    height: 285,
    x: 234,
    y: -8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M234.864 209.036 451.4-7.5l67.175 67.175-216.536 216.536z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3,
    d: "m253.339 149.574-12.144 12.145 14.256 14.257v12.672h12.673l13.729 13.729 12.145-12.145M278.685 124.228l-12.145 12.145 14.257 14.257v12.673h12.673l13.729 13.729 12.145-12.145M304.031 98.883l-12.145 12.144 14.257 14.257v12.673h12.673l13.729 13.729 12.144-12.145M329.376 73.537l-12.145 12.145 14.257 14.257v12.672h12.673l13.729 13.729 12.145-12.145"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5,
    d: "m354.722 48.191-12.145 12.145 14.257 14.257v12.673h12.673l13.729 13.729 12.145-12.145"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h336v200H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationArticle);
export default __webpack_public_path__ + "static/media/illustration-article.082cca317c8b4b2c973fa73013373085.svg";
export { ForwardRef as ReactComponent };